export default __webpack_public_path__ + "static/media/armory.d871f1b1.svg";